'use strict';
import Vue from 'vue';
import App from './components/publicSchedule/App';
import store from './store/publicSchedule';
import router from './router/public.js';

if (document.getElementById('publicApp')) {
	new Vue({
		name: 'PublicSchedule',
		el: '#publicApp',
		template: '<App />',
		store,
		router,
		components: {
			App
		}
	});
}
